// Reading-host I/O only; rigid owns syntax/validation/rendering. Every save is an ordinary server-validated mutation.
import { platformPrompt, recordRenderer } from "@hq-org/platform-wasm";
import { WASM } from "./net";
type Rec = Record<string, any>;
type Query = (query: string, variables?: Rec) => Promise<Rec>;
const core = (v: Rec) => platformPrompt(v, WASM);
export async function promptTool(q: Query, name: "prompt_render" | "prompt_save", a: Rec): Promise<Rec> {
  const vars = a.variables ?? {};
  if (name === "prompt_render") {
    const host = recordRenderer(core, q);
    return { text: a.source != null ? await host.render(a.source, vars, a.data) : await host.record(a.id ?? a.skill ?? a.page, a.field, vars) };
  }
  const p = await core({ source: a.source, vars, inspect: true });
  const field = a.field ?? (a.kind === "hq.agents.Agent" ? "prompt" : "body");
  await core({ record: { [field]: p.body, render: p.metadata.render }, schema: a.schema ?? "" });
  const { kinds } = await q("query($kind: String!) { kinds(filter: {name: {eq: $kind}}) { nodes { info } } }", { kind: a.kind });
  const key = kinds.nodes[0]?.info.patch;
  if (!key) throw new Error("kind not visible");
  const fields: Rec = { [field]: p.body, render: p.metadata.render ?? null };
  let forked = false;
  if (a.kind === "hq.agents.Skill") {
    const { skills } = await q("query($id: ID!) { skills(filter: {id: {eq: $id}}) { nodes { name description package space { id } files { nodes { id } } } } }", { id: a.id });
    const old = skills.nodes[0];
    if (!old) throw new Error("Skill not visible");
    forked = !!old.package;
    fields.description = a.description ?? old.description;
    const hash = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(JSON.stringify(fields)));
    fields.version = [...new Uint8Array(hash)].map((x) => x.toString(16).padStart(2, "0")).join("");
    if (forked) Object.assign(fields, { name: old.name, space: old.space.id, files: { add: old.files.nodes.map((f: Rec) => f.id) } });
  }
  const result = forked
    ? await q("mutation($p: Patch!) { create(patch: $p) { id } }", { p: { [key]: fields } })
    : await q("mutation($id: ID!, $p: Patch!) { update(id: $id, patch: $p) { id } }", { id: a.id, p: { [key]: fields } });
  return { id: (result.create ?? result.update).id, forked };
}
